import { useQuery } from "@tanstack/react-query";

import { useConnectionState } from "@/shared/realtime";

import { isAnalysisFinished } from "../model/isAnalysisFinished";
import { analysisQueryOptions } from "./analysisQueryOptions";
import { POLL_INTERVAL_MS } from "./POLL_INTERVAL_MS";

// Готовящийся разбор свежий, как по умолчанию в app/queryClient.
const IN_PROGRESS_STALE_TIME_MS = 30_000;

// Разбор матча. Пока он готовится, шаги приходят событиями `analysis.*`;
// без соединения с Centrifugo — опрос раз в 5 секунд. Готовый или упавший разбор
// больше не меняется: из кэша, без перезапросов (событие разбора всё равно его инвалидирует).
export const useAnalysis = (analysisId: number) => {
  const connection = useConnectionState();
  return useQuery({
    ...analysisQueryOptions(analysisId),
    staleTime: (query) => {
      const status = query.state.data?.status;
      return status !== undefined && isAnalysisFinished(status)
        ? Infinity
        : IN_PROGRESS_STALE_TIME_MS;
    },
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (connection === "connected" || status === undefined || isAnalysisFinished(status)) {
        return false;
      }
      return POLL_INTERVAL_MS;
    },
  });
};
